import React from 'react';

export default function DocumentosPage() {
  return (
    <div>
      Qualidade - Documentos (placeholder).
    </div>
  );
}

